export default "__VITE_ASSET__C3YzQ4rO__"